import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Row, Col, Button } from 'react-bootstrap';
import appConstant from '../../../../constants/app';

class HideGroupForm extends PureComponent {
  static propTypes = {
    groupId: PropTypes.number,
    label: PropTypes.string,
    hidden: PropTypes.number,
    onClose: PropTypes.func,
    onAccept: PropTypes.func,
  };

  state = {
    sectionId: null,
  }

  sectionHideOrShow = () => {
    axios({
      method: 'post',
      url: `${appConstant.API_URL}/section/hide?access_token=${localStorage.getItem('token')}`, 
      data: {
        id: this.props.groupId,
      },
    }).then(res => {
      const sectionId = res.data.section.parent_id;
      this.props.onClose();
      this.props.onAccept(sectionId);
    }).catch(err => {
      console.log(err);
    });
  }

  render () {
    const {
      label,
      hidden,
      onClose,
    } = this.props;

    return (
      <div className="confirmation-modal-body">
        <Row>
          <Col sm={12}>
            <p className="modal-paragraph">
              If you {`${hidden === 0 ? 'hide' : 'show' } `} {label}, the
              information will {`${hidden === 0 ? 'not' : '' } `} be visible
              on the site {`${hidden === 0 ? 'but' : 'and' } `} it will remain on the backend in case you
              want to {`${hidden === 0 ? 'show' : 'hide' } `} it after.
            </p>
          </Col>
        </Row>
        <Row className="confirmation-btns-footer">
          <Col sm={12}>
            <Button
              className="cancel-btn"
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              onClick={this.sectionHideOrShow}
              className="accept-btn"
            >
              Accept
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}

export default HideGroupForm;


// WEBPACK FOOTER //
// ./src/app/screens/sections/groupsSection/hideGroupForm.js